module.exports = __webpack_public_path__ + "assets/142f60a7acbcd0b98c3f1b7d19350dc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/hu/video.jpg
// module id = 345
// module chunks = 1